<template>
  <div>
    <section class="catg-area ptop-5 section-header">
      <div class="container">
        <form @submit.prevent="handleSearch">
          <div class="search-container d-flex justify-content-start">
            <div class="search-title mt-1 ml-2">
              <p class="dark-gray font-bold">
                キーワード絞り込み
              </p>
            </div>
            <div class="search-row-container">
              <div
                class="search-row d-flex align-items-center justify-content-center mb-3"
              >
                <!-- <label for="jd_search_or">いずれかを含む</label> -->
                <input
                  type="text"
                  name="jd_search_or"
                  v-model="searchOrValue"
                  placeholder="複数キーワードの場合はスペース区切りで入力してください"
                  class="search-input font-14"
                  @change="handleSearch"
                />
              </div>
            </div>
          </div>
          <!-- <div class="d-flex justify-content-center">
            <button @click="handleSearch" class="search-btn">
              検索
            </button>
          </div> -->
        </form>
      </div>
    </section>
  </div>
</template>

<script>
import ApiService from '@/service/apiService';
import GlobalPaginate from '@/components/utils/GlobalPaginate.vue';
import Loader from '../../utils/Loader.vue';
import Api from '@/config/api';
import moment from 'moment';
import JDRow from './JDRow.vue';
import { mapGetters, mapMutations } from 'vuex';
// import debounce from 'debounce';

export default {
  name: 'JDFilter',
  components: { JDRow, GlobalPaginate, Loader },
  computed: {
    ...mapGetters({
      getJdFilterState: 'jd/getJdFilterState',
      getCurrentPage: 'jd/getCurrentPage',
      getTotalPages: 'jd/getTotalPages',
      getLoading: 'jd/getLoading',
      getJdClientStatus: 'jd/getJdClientStatus',
    }),
    searchAndValue: {
      get() {
        return this.getJdFilterState.jdSearchAnd;
      },
      set(value) {
        this.setSearchAnd(value);
      },
    },
    searchOrValue: {
      get() {
        return this.getJdFilterState.jdSearchOr;
      },
      set(value) {
        this.setSearchOr(value);
      },
    },
  },
  methods: {
    ...mapMutations({
      setAllJds: 'jd/setAllJds',
      setJdPage: 'jd/setJdPage',
      setTotalPages: 'jd/setTotalPages',
      setLoading: 'jd/setLoading',
      setSearchAnd: 'jd/setSearchAnd',
      setSearchOr: 'jd/setSearchOr',
      setSortState: 'jd/setSortState',
      resetFilters: 'jd/resetFilters',
      resetSort: 'jd/resetSort',
      setLoading: 'jd/setLoading',
    }),
    // handleSearch: debounce(function(){
    //     this.getAllJDs(this.buildParams(1));
    // },500),
    handleSearch() {
      this.getAllJDs(this.buildParams(1));
      this.resetSort();
      // this.$router.push({
      //   name: 'jd-user-list',
      // });
    },
    async getAllJDs(params = {}) {
      try {
        this.setLoading(true);

        const response = await ApiService.get(
          Api.endpoints.ALL_JDS,
          {},
          params
        );

        const { jDs, totalPages } = response.data.data;
        this.setAllJds(jDs);
        this.setTotalPages(totalPages);
      } catch (error) {
        console.error('Error fetching JDs:', error);
      } finally {
        this.setLoading(false);
      }
    },
    formatDate(date) {
      return moment(date).format('YYYY/MM/DD');
    },
    changePage(page) {
      this.setJdPage(page);
      this.scrollToTop();
    },
    // setJdPage(page) {
    //     this.pageNumber = page;
    // },
    buildParams(page = null) {
      return {
        page: page || this.getCurrentPage,
        jdSearchAnd: this.getJdFilterState.jdSearchAnd,
        jdSearchOr: this.getJdFilterState.jdSearchOr,
        sort: this.getJdFilterState.sortBy,
      };
    },
  },
  mounted() {
    this.changeBodyBackground();
  },
  // async created() {
  //     console.log(this.allJDs);
  //     if(!this.allJDs || this.allJDs.length === 0) {
  //         await this.getAllJDs(this.buildParams(1));
  //     }
  // },
  watch: {
    // allJDs: {
    //     handler(newVal) {
    //         if (!newVal || newVal.length === 0) {
    //             this.getAllJDs();
    //         }
    //     },
    //     deep: true
    // },
    // 'getJdFilterState.pageNumber': function(currentPage) {
    //     this.getAllJDs(this.buildParams(currentPage));
    // }
  },
};
</script>

<style scoped>
.search-container {
  gap: 40px;
}
.arrow-link i {
  color: #d0c2c2;
}
.arrow-link i.active {
  color: #036d6c;
}

.ptop-5 {
  padding-top: 5px !important;
}

.table {
  border-collapse: collapse;
  width: 100%;
  font-size: 16px;
}

.table th {
  /* padding: 30px 10px 20px 10px; */
  padding: 5px;
  /* text-align: left; */
  border-bottom: 1px solid black;
}
.table th {
  font-size: 18px;
  border-top: none;
  color: #006c6b;
}

.search-btn {
  background-color: #006c6b;
  color: white;
  padding: 10px 20px;
  border-radius: 5px;
  border: none;
  min-width: 160px;
  height: 50px;
  font-size: 16px;
}

.search-input {
  /* background-color: #DEDEE0; */
  padding: 10px;
  width: 507px;
  height: 33px;
  margin-left: 20px;
  border: 1px solid #3c3c3c;
  color: #7a7e82;
}
.search-input::placeholder {
  color: #7a7e82;
}

.search-input:focus-within {
  /* Reset properties to their default values */
  border: 1px solid #7a7e82 !important;
}
</style>
